import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import Arrow from "../../../assets/arrow_icon.svg"
import Dot from "../../../assets/dot.svg"
import {
  animationSlideUp,
  animationSlideRight,
  animationSlideLeft,
  animationFade,
} from "../../utils/scroll-animation"
import Hints from "../../common/hints/hints"

export default function Solutions(props) {
  const { content, styles } = props
  const [stepIndex, setStepIndex] = useState(0)
  const [process, setProcess] = useState([])

  useEffect(() => {
    setProcess(content.steps[stepIndex].process)
  }, [])

  const setVal = (step, index) => {
    setProcess(step.process)
    setStepIndex(index)
  }

  const renderProcessCard = () => {
    return (
      process.length > 0 &&
      process.map(item => (
        <div key={item.name} className={styles.process}>
          <div className={styles.processTitle}>
            <Arrow className={styles.arrow} />
            <h3>{item.name}</h3>
          </div>
          <div className={styles.processText}>
            <p>{item.description}</p>
          </div>
        </div>
      ))
    )
  }

  return (
    <section
      style={{
        backgroundColor: content?.backgroundColor
          ? content.backgroundColor.hex
          : "",
      }}
      className={styles.solutions}
    >
      <div className={`default-container ${styles.solutionsWrapper}`}>
        <div className={styles.solutionsContainer}>
          <div className={styles.titleWrapper}>
            <h1 {...animationSlideRight()}>{content.title}</h1>
            <Hints
              hints={content?.hints}
              isAnimation={content?.isHintsAnimation}
              typingBackground={
                content?.backgroundColor
                  ? content.backgroundColor.hex
                  : "#673895"
              }
            />
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.content}>
              <div className={styles.list} {...animationSlideRight()}>
                {content.steps.map((step, index) => (
                  <div
                    className={`${styles.steps} ${
                      stepIndex == index ? styles.activeStep : ""
                    }`}
                    key={index}
                  >
                    <span>
                      <Dot className={styles.dot} />
                    </span>
                    <span className={styles.numbers}>{index + 1}.</span>{" "}
                    <p onMouseEnter={() => setVal(step, index)}>{step.name}</p>
                  </div>
                ))}
              </div>
              <div className={styles.processContainer} {...animationFade()}>
                {renderProcessCard()}
                <div className={styles.link}>
                  {" "}
                  <Link to="/case-study"> Case Study</Link>{" "}
                  <Arrow className={styles.arrowLink} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
